// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated by scripts/generate-icon-and-image.ts
export const iconNames = ["ach-transfer","bank-transfer","calendar","card","download","file_pdf","grid","inventory","list","payment-check","paypal","send-request","xlxs"] as const;
export type IconName = typeof iconNames[number];

export const imageNames = ["aftermarket","aftermarket-express","amazon","ebay","gt-engine","stripe","wallmart","zoho"] as const;
export type ImageName = typeof imageNames[number];

export const imagePaths = {
  "aftermarket-express": "/src/assets/images/aftermarket-express.png",
  "aftermarket": "/src/assets/images/aftermarket.png",
  "amazon": "/src/assets/images/amazon.png",
  "ebay": "/src/assets/images/ebay.png",
  "gt-engine": "/src/assets/images/gt-engine.png",
  "stripe": "/src/assets/images/stripe.png",
  "wallmart": "/src/assets/images/wallmart.png",
  "zoho": "/src/assets/images/zoho.png"
} as const;
